import { tap, skip, map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../authentication/authentication.service";
const credentialsKey = 'currentUser';
export class UsersService {
    constructor(http, authenticationService) {
        this.http = http;
        this.authenticationService = authenticationService;
        this.isSaveAndExit = new BehaviorSubject({ isSaveAndExit: false, currentForm: null });
        this.userDetails = new BehaviorSubject(null);
        this.userDetailsObs = this.userDetails.asObservable();
    }
    registerUser(data) {
        const href = `${environment.register}`;
        return this.http.post(href, data).pipe(tap((data) => {
            if (data.status === 'success') {
                this.authenticationService.setUser(data.response);
            }
            return data;
        }));
    }
    updateUserProfile(payload) {
        const href = `${environment.updateProfile}`;
        return this.http.post(href, payload).pipe(tap((data) => {
            if (data.status === 'success') {
            }
            return data;
        }));
    }
    setCurrentApplication(application) {
        sessionStorage.setItem("application", JSON.stringify(application));
    }
    removeApplication() {
        sessionStorage.removeItem("application");
    }
    getCurrentApplication() {
        const data = sessionStorage.getItem("application") ? (JSON.parse(sessionStorage.getItem("application")) || null) : null;
        // if(data && data.renewed_application_details){
        //   return data.renewed_application_details
        // }
        return data;
    }
    checkSaveAndExit() {
        return this.isSaveAndExit.asObservable().pipe(skip(1));
    }
    getApplicationList(pagination) {
        const href = environment.getApplicationList;
        return this.http.get(href, { params: pagination }).pipe(map((data) => {
            if (data.status == 'success') {
                return data;
            }
        }));
    }
    getExpiringApplications(pagination) {
        const href = environment.getExpiringApplications;
        return this.http.get(href, { params: pagination }).pipe(map((data) => {
            if (data.status == 'success') {
                return data;
            }
        }));
    }
    getApplicationById(id) {
        const href = environment.getApplicationById;
        return this.http.get(href, { params: id }).pipe(map((data) => {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    }
    renewPermit(payload) {
        // const href = environment.renewPermit;
        // return this.http.get<any>(href, {params: id}).pipe(map((data: any) => {
        //   if (data.status == 'success') {
        //     return data.response;
        //   }
        // }));
        const href = `${environment.renewPermit}`;
        return this.http.post(href, payload).pipe(tap((data) => {
            if (data.status === 'success') {
            }
            return data;
        }));
    }
    getCityList() {
        const href = environment['getCityList'];
        return this.http.get(href).pipe(map((data) => {
            if (data.status == 'success') {
                return data.response;
            }
        }));
    }
    setSelectedCity(id) {
        sessionStorage.setItem('selectedCity', id);
    }
    getSelectedCity() {
        return sessionStorage.getItem('selectedCity');
    }
    removeSelectedCity() {
        sessionStorage.removeItem('selectedCity');
    }
    verifiyOtpProfile(data) {
        const href = environment.verifiyOtpProfile;
        return this.http.post(href, data).pipe(map((res) => {
            if (res.status === 'success') {
                const storage = localStorage;
                storage.setItem(credentialsKey, JSON.stringify(res.response));
            }
            if (res.status == 'success') {
                return res;
            }
        }));
    }
    sendProfileOtp(payload) {
        const href = environment.sendProfileOtp;
        return this.http.get(href, { params: payload }).pipe(map((data) => {
            if (data.status == 'success') {
                return data;
            }
        }));
    }
}
UsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UsersService_Factory() { return new UsersService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.AuthenticationService)); }, token: UsersService, providedIn: "root" });
